import {Component, inject, input, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoDirective, TranslocoPipe} from '@jsverse/transloco';
import {TooltipModule} from 'primeng/tooltip';
import {Chapter, StepStatus} from '../../../../project-sequence/project-step.types';
import {
  ButtonSeverity,
  CardLevel,
  GenericButtonCardComponent,
} from '../../../../../../shared/components/card/button-card/generic-button-card.component';
import {ProgressBarComponent} from '../../../../../../shared/components/progress-bar/progress-bar.component';
import {ProjectSideMenuAccessControlService} from '../../../../project-sequence/project-side-menu/project-side-menu-access-control.service';
import {ProjectChapterType} from '@frontend/shared';

@Component({
  selector: 'app-project-chapter-progress-card',
  imports: [
    CommonModule,
    TranslocoDirective,
    GenericButtonCardComponent,
    ProgressBarComponent,
    TranslocoPipe,
    TooltipModule,
  ],
  templateUrl: './project-chapter-progress-card.component.html',
})
export class ProjectChapterProgressCardComponent {
  readonly chapter = input.required<Chapter>();
  readonly index = input.required<number>();
  readonly chapters = input<Chapter[]>([]);
  readonly isAccessible = input(true);
  readonly goToChapter = output<ProjectChapterType>();

  protected readonly accessControlService = inject(ProjectSideMenuAccessControlService);

  getChapterButtonSeverity(): ButtonSeverity | undefined {
    const chapter = this.chapter();
    if (this.accessControlService.isChapterInDevelopment(chapter.configId)) {
      return undefined;
    }

    const completedSteps = chapter.steps.filter(
      (step) => step.status === StepStatus.COMPLETED,
    ).length;
    const totalSteps = chapter.steps.length;

    if (completedSteps === totalSteps) {
      return undefined;
    }
    return ButtonSeverity.Primary;
  }

  isStepDisabled(): boolean {
    return (
      !this.isAccessible() ||
      this.accessControlService.isChapterInDevelopment(this.chapter().configId)
    );
  }

  onGoToChapter() {
    this.goToChapter.emit(this.chapter().configId);
  }

  get completedSteps(): number {
    return this.chapter().steps.filter((step) => step.status === StepStatus.COMPLETED).length;
  }

  get totalSteps(): number {
    return this.chapter().steps.length;
  }

  get chapterNumberTitle(): string {
    return `${this.chapter().chapterUiNumber}. ${this.chapter().translatedTitle}`;
  }

  getTooltipText(): string | undefined {
    if (!this.isAccessible()) {
      return 'projectStep.noAccess';
    }
    return undefined;
  }

  protected readonly CardLevel = CardLevel;
}
